import BaseApi from './BaseApi';

/**
 * お問い合わせ終了API。
 */
class ChatProhibitedApi extends BaseApi {
  async close(id: string) {
    return await this.execute('chatProhibitedApi', {
      method: 'POST',
      body: {
        partnerId: id
      }
    }).then(({ status }) => status === 1);
  }
}

export default ChatProhibitedApi;
